import type { MailInterval } from "../state/mail";

export const MAIL_INTERVALS: [MailInterval, string][] = [["5m", "5 分鐘"], ["15m", "15 分鐘"], ["30m", "30 分鐘"], ["1h", "1 小時"]];

/** The text the mailbox copies for an agent to check mail and markers on a schedule (spec 2j §4.3).
 *  It names no agent: the MCP token already says which one reads it. */
export function mailPrompt(interval: MailInterval): string {
  const words = MAIL_INTERVALS.find(([v]) => v === interval)![1];
  return [
    `/loop ${interval} 查看 Nomen Land 的信箱與標記：`,
    "1. 呼叫 read_mail。有信就照我的要求做，做完或需要我釐清時用 send_mail 回覆。",
    "2. 對你是 builder 的每塊領地呼叫 list_markers（status=open，不帶 wait_seconds），在草稿實作並用 resolve_marker 回報。",
    "3. 都沒事就結束這一輪，不要寄信說沒事。promote 前先問我，我回了同意你就自己 promote。",
    "",
    `如果你不是 Claude Code：用你的客戶端的排程功能，每 ${words}做一次上面三步；沒有排程功能就告訴我。`,
  ].join("\n");
}
